import { NarratorNPC } from '../../../../src/feature/narrator/narrator.model';
import { dialog } from './dialog';

export const niklas: NarratorNPC = {
  id: 'niklas',
  name: 'Niklas',
  dialog: dialog,
};
